<div
  class="group font-lato relative flex items-start justify-between gap-4 max-[1375px]:items-baseline max-[375px]:flex-col lg:items-center"
  [class.selected]="isSelected"
>
  <div class="mr-0 md:mr-10">
    <h5 class="text-base leading-tight font-bold">
      {{ order.Name || '' }} ({{
        order.Status__c === 'Ready' ? 'Pending' : order.Status__c
      }})
    </h5>
    @if (order.Status__c === 'Pending' || order.Status__c === 'Ready') {
      <div
        class="mt-1 overflow-hidden text-xs text-nowrap text-ellipsis text-amber-600"
      >
        The order is still in initial processing, not all services may be
        displayed
      </div>
    }
  </div>
  <div
    class="text-brand-muted flex min-w-41 items-center text-xs max-[767px]:mt-1"
  >
    Order date:
    <span class="pl-2.5 font-semibold text-blue-950">
      {{ (order.Order_Date__c | date: 'MM/dd/yy') || '---' }}
    </span>
  </div>

  <a
    [routerLink]="order.Id"
    tabindex="-1"
    class="absolute inset-0 z-10 block w-full rounded-xl border-none bg-transparent p-0 md:hidden"
  >
    <div class="order-link opacity-0">View Order</div>
  </a>
</div>
